import React, { Component } from 'react';
import Moment from 'moment';
import imageCompression from 'browser-image-compression';

import {AncOrigin, timeoutPre, timeoutPost, getPageType, getConv, cancelFeedback, checkUserTextValue,
    closeNotification, appendLoader, removeLoader, appendUserTextMessage, resetMessageContainer,
    resetVisitorsMessages, openLiveAgent, forOTP, getUserTextOTPValue, forNationalId, getUserTextNationalIdValue,
    forIBAN, getUserTextIBANValue, PostThis, Origin, getBase64, forPhone, getUserTextPhoneValue,
    getUserTextRequestValue, forRequest, getUserTextUDSValue, forUDS} from "../utils/general";

import ChatHeader from './ChatHeader';
import TopContainer from './TopContainer';
import Notify from './Notification';
import FeedbackPopup from './FeedbackPopup';
import UserInputArea from './UserInputArea';
import SendButton from './SendButton';
import PopupModal from './PopupModal';
import PopupAlert from './PopupAlert';
import WelcomeModal from './WelcomeModal';
import TimeoutScreen from './TimeoutScreen';
import MessageContainer from './MessageContainer';

import fetch from 'node-fetch';
import { console, window, document, setTimeout } from "global";
const $ = window.$;
import {_client} from "../utils/fsclient";
import { sample_response } from '../../data/test-response';
import { test_combined, test_data } from '../../data/sample-data';

// Frontend session time-out config * times needs in seconds
const sessionTime = 420; //420 in seconds, 7 mins
const sessionTimeTest = 750; //420 in seconds, 7 mins
const file_upload_limit = 5819596; //5767168 in bytes, 5.5MB 2931155[2.7]
class ChatBot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIcon:'female',       /* Change for bot icon: female, male */
            currentLanguage:'en',       /* Change for Language: ar, en */
            arbTitle:'مساعدك الافتراضي',   /* Bot name in Arabic */
            engTitle:'Alkahraba',   /* Bot name in English - Alkahraba bot*/
            isWelcomeScreen:true,       /* Show welcome screen with Language options */
            isTimeoutScreen:false,      /* Show Timeout Message screen with Refresh */
            isAgent:false,              /* Update if agent is connected: true */
            isFeedbackPupup:false,       /* Feedback Popup enable/disable */
            isSpeaker:false,            /* Speake function enable/disable */
            isMic:false,                /* Mic function enable/disable */
            isLanguageBtn:true,         /* To change Language header button */
            logs:'',                    /* Set Notify message to log */
            disableUsersAct:{textBx:false,refreshBtn:false,sendBtn:false},         /* To disable input, send/refresh button for user */
            login_details:[],           /* User session data*/
            ccount:0,                   /* Conversation counter */
            username:'User',            /* To set username if provided any */
            token:token,                /* Token set for every session (set in jsp) */
            /* payloads data */
            timestamp:Moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            timezone:Moment(new Date()).format("Z").replace('+', ' +'),
            conv_id:'',
            listDisplay:false,
            keywords:'',
            getConvCount:0,
            query_count:0,
            query_hindi:'',
            freeText:false,
            /* payloads data */
            messageListsData:[],          /* Collect all messages */
            uservalue:'',                 /* User text inputed */
            preventAction:false,            /* Prevent Refresh and Language on message loading */
            var1:var1,                      /* BP URL params */
            var2:var2,                      /* URL params */
            var3:var3,                      /* URL params - Language */
            inputTypeIs:'',                 /* Check if any input type is set in conversation response */
            tout:0,
            trem:0,
            selectedFile:'',                /* contains information on the currently picked file */
            isFilePicked:false,             /* determines if a file has been picked or not */
            invalidImage:false,             /* determines if a file has been picked with valid formats */
            allowTypes:'image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document', /* allow file types to upload */
            isLocationScreen:false,         /* Show Location picker Message screen */
            locationValue:'',               /* Selected Location's latitude and longitude coordinates */
            filevalue:'',                   /* Selected Uploaded files value set it to hidden input in UploadFile.js */
            filetype:'',                    /* File type / extention */
            filename:'',                    /* File only name without path */
            filebase64:'',                  /* File base64 value */
			preventDoubleClick:false,       /* Preventing double click on-button */
            compressedFile:null,
            billDate:null,                  /* To get user bill date */
            chatStatus: false,              /* To handle green dot status */
            isActive: false,                /* To handle send Button color */
            isBusy: false,                  /* To check if getUrl() already in process */
            isDropdown:'',
            timeoutId: '',
            isMainMenu: false,              /* To check if inputType is MainMenu*/
            setGeoPosition: {lat: 24.176869443745133, lng: 46.068425139287385},
            isFeedBack:'',
            isAgent: false,
            compressionProgress:0,          /* Image compression progress */
            isInvalidImage:false,           /* Show Error Message for Inavalid image */
            isTestData: false,               /* To set dummay data for test */
        }
    }

    resize = () => getPageType();       /* Updated UI for mobile/desktop */

    getuserparam=(name, url) => {
    	if (!url) url = location.href;
    	name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    	var regexS = "[\\?&]"+name+"=([^&#]*)";
    	var regex = new RegExp( regexS );
    	var results = regex.exec( url );
    	return results == null ? null : results[1];
    };
    
    componentDidMount() {
        let oUrl = document.location.href;
        let var3 = this.getuserparam('var3',oUrl);       
        const webLang = ['ar-SA', 'AR'].includes(var3) || var3 === null || var3==='null' ? 'ar' : 'en';
        window.addEventListener('load', this.resize);
        window.addEventListener('resize', this.resize);
        this.setState({disableUsersAct:{textBx:false,refreshBtn:false,sendBtn:false}});
        this.setState({currentLanguage:webLang});
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize)
    }

    startNewConversation=()=>{
        if(!this.state.isBusy) {this.geturl()}
    }
    
    geturl = ()=>{
        fetch('login', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token:this.state.token
            })
        })
        .then(async response => {
            const data =  await response.json();
            this.setState({login_details:data, isBusy: true});
            forOTP();
            forNationalId();
            forIBAN();
            forPhone();
            forRequest();
            forUDS();
            await this.getConversationn('hi');
        })
    }

    saveClientsData=(session)=>{
        fetch('saveClientInfo', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token: this.state.token,
                session: session,
                os: _client.getOs(),
                os_ver: _client.getOsVersion(),
                browser: _client.getBrowser(),
                browser_ver: _client.getBrowserVersion(),
                browser_maj_ver: _client.getBrowserMajorVersion(),
                device_type: _client.getDevicetype(),
                screen: _client.getScreenSize(),
                cookie_status: _client.getCookieStatus()
            })
        })
        .then(async response => {
            await response.json();
        }).catch(function(err) {});               
    }

    getConversationn=(userio)=>{
        if(userio == "onPropertyDelay"){
    		clearTimeout(this.state.timeoutId);
    	} else if (userio == "Change Property Name" || userio == "تغيير اسم العقار"){
    		clearTimeout(this.state.timeoutId);
    	}
        this.setState({ccount: this.state.ccount + 1}, () => { /*console.log(this.state.ccount)*/ });
        this.setState({ccount: this.state.ccount + 1});
        appendLoader();
        let payload = {};        
        if(this.state.inputTypeIs==='File' ){
            if(userio==='Back' || userio=='Main Menu'){
                payload['message'] = userio;                
            } else if(userio==='الرجوع للخلف' || userio=='القائمة الرئيسية'){
                payload['message'] = userio;                
            } else {
                let fileInfo={};
                fileInfo['name']=this.state.filename;
                fileInfo['type']=this.state.filetype;
                fileInfo['base64']=this.state.filebase64;
                payload['message'] = this.state.filename;
                payload['file_info'] = fileInfo;
            }            
        } else {
            payload['message'] = userio;
        }
        payload['token'] = this.state.token;
        payload['session_id'] = this.state.login_details.sessionid;
        payload['conv_timestamp'] = this.state.timestamp;
        payload['conv_timezone'] = this.state.timezone;
        payload['conv_id'] = this.state.conv_id;
        payload['url_data'] = document.referrer;
        payload['username'] = this.state.username;
        payload['query_hindi'] = this.state.query_hindi;
        payload['link'] = document.referrer;
        payload['lang']=this.state.currentLanguage;
        payload['var1']=this.state.var1;
        payload['var2']=this.state.var2;
        payload['var3']=this.state.var3;        
        // console.log(payload);
        
        fetch('conversation',{
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify(payload)
        })
        .then(async response =>{
            const ndata =  this.state.isTestData? test_data.english.invalidImage : await response.json();
            let udata = this.state.isTestData? test_combined :this.state.messageListsData;
            // let udata = this.state.messageListsData;
            this.setState({isBusy:false, selectedFile:'', isFilePicked:false, filevalue:'', filetype:'', filename:'', filebase64:'', uservalue:''});
            if(ndata.message==='Something unexpected happened!'){
                removeLoader(this.state.inputTypeIs);
                clearInterval(this.state.tout); this.timeOut();
                udata.push({id:this.state.ccount, data:{ndata}});
                this.setState({messageListsData:udata}, () => { /*console.log(this.state.messageListsData)*/ });
                this.setState({disableUsersAct:{textBx:false,refreshBtn:false,sendBtn:false},uservalue:'',preventAction:false});
            } else {
                if(Object.prototype.hasOwnProperty.call(ndata, 'inputType')) {
                    this.setState({inputTypeIs:ndata.inputType});
                }
                if(Object.prototype.hasOwnProperty.call(ndata.element, 'dropdown')) {
                    this.setState({isDropdown:ndata.element.dropdown});
                } else {
                    this.setState({isDropdown:''});
                }
                if(Object.prototype.hasOwnProperty.call(ndata.element, 'feedbackBtn')) {
                    this.setState({isFeedBack:ndata.element.feedbackBtn});
                } else {
                    this.setState({isFeedBack:''});
                }
                if(this.state.inputTypeIs==='timeout'){
                	this.setState({isTimeoutScreen:true});
                } else {
                	this.setState({isTimeoutScreen:false});
                }
                if(this.state.inputTypeIs==='invalidimage'){
                	this.setState({isInvalidImage:true});
                } else {
                	this.setState({isInvalidImage:false});
                }
                if(this.state.inputTypeIs==='Mainmenu'){
                    this.setState({isMainMenu:true});
                } else {
                    this.setState({isMainMenu:false});
                }
                removeLoader(this.state.inputTypeIs);
                clearInterval(this.state.tout); this.timeOut();
                udata.push({id:this.state.ccount, data:{ndata}});
                this.setState({messageListsData:udata,preventDoubleClick:false}, () => { /*console.log(this.state.messageListsData)*/ });
                if(this.state.inputTypeIs==='Account' && this.state.isDropdown!==''){
                    this.setState({disableUsersAct:{textBx:true,refreshBtn:false,sendBtn:true},uservalue:'',preventAction:false});
                } else if(this.state.inputTypeIs==='Account' && this.state.isDropdown===''){
                    this.setState({disableUsersAct:{textBx:false,refreshBtn:false,sendBtn:false},uservalue:'',preventAction:false});
                } else if((this.state.inputTypeIs==='Request' || this.state.inputTypeIs==='UDS') && this.state.isDropdown!==''){
                    this.setState({disableUsersAct:{textBx:true,refreshBtn:false,sendBtn:true},uservalue:'',preventAction:false});
                } else if((this.state.inputTypeIs==='Request' || this.state.inputTypeIs==='UDS') && this.state.isDropdown===''){
                    this.setState({disableUsersAct:{textBx:false,refreshBtn:false,sendBtn:false},uservalue:'',preventAction:false});
                } else if(this.state.inputTypeIs==='File' || this.state.inputTypeIs==='Location' || this.state.inputTypeIs==='DatePicker'){
                    this.setState({disableUsersAct:{textBx:true,refreshBtn:false,sendBtn:false},uservalue:'',preventAction:false});
                } else if(this.state.inputTypeIs==='lastMessage'){
                    this.setState({disableUsersAct:{textBx:true,refreshBtn:false,sendBtn:true},uservalue:'',preventAction:false});
                } else if(this.state.isFeedBack!==''){
                    this.setState({disableUsersAct:{textBx:true,refreshBtn:false,sendBtn:false},uservalue:'',preventAction:false});
                } else if(this.state.inputTypeIs==='Properties') {
                    // On property if user not taken any action within 30 sec then 
                	this.state.timeoutId = setTimeout(() => {
                        this.getConversationn('onPropertyDelay');
                    }, 30000);
                } else if(this.state.inputTypeIs==='IBAN'){
                    this.setState({disableUsersAct:{textBx:false,refreshBtn:false,sendBtn:false},uservalue:'SA',preventAction:false});
                } else if(this.state.inputTypeIs==='Phone'){
                    this.setState({disableUsersAct:{textBx:false,refreshBtn:false,sendBtn:false},uservalue:'+966',preventAction:false});
                } else if(this.state.inputTypeIs==='Payment'){
                    this.setState({disableUsersAct:{textBx:false,refreshBtn:false,sendBtn:false},uservalue:'',preventAction:false});
                // } else if(this.state.inputTypeIs==='invalidimage'){
                //     appendUserTextMessage(this.state.currentLanguage,this.state.inputTypeIs,this.state.var1);
                } else {
                    this.setState({disableUsersAct:{textBx:false,refreshBtn:false,sendBtn:false},uservalue:'',preventAction:false});
                }
            }
        })
        // .catch(function(){
        //     console.log("Somthing unexpected happens");
        // });
    }

    getConvHandler = (e) => {
        e.stopPropagation();
        // console.log(e.target.className);
        let apName='', apMobile='', apContractNo='', apChatHistory='', btnText='', apEntryPointId='', apTemplateName='', apLocale='';
        let usrio = e.target.title;
        let usertext = checkUserTextValue(usrio,this.state.inputTypeIs,this.state.var1);
        if(!usertext && (usrio!=='Back' || usrio!=='الرجوع للخلف')){ // TODO : update arabic back text
            if(this.state.inputTypeIs!=='Account' || this.state.inputTypeIs!=='Phone' || this.state.inputTypeIs!=='NationalId' || this.state.inputTypeIs!=='Payment'){
                appendUserTextMessage(this.state.currentLanguage,this.state.inputTypeIs,this.state.var1);
            }
        } else {
            this.setState({preventDoubleClick:true});
            if(e.target.className==='btnAgentLink'){
                apName = e.target.getAttribute("data-name");
                apMobile = e.target.getAttribute("data-mobile");
                apContractNo = e.target.getAttribute("data-contractno");
                apChatHistory = e.target.getAttribute("data-chathistory");
                apEntryPointId = e.target.getAttribute("data-entryPointId");
                apTemplateName = e.target.getAttribute("data-templateName");
                apLocale = e.target.getAttribute("data-locale");
                // console.log("Name: ", apName, ", Mobile: ", apMobile, ", Contract No: ", apContractNo);
                openLiveAgent(apName,apContractNo,apMobile,apChatHistory,this.state.currentLanguage,this.state.var1,apEntryPointId,apTemplateName,apLocale);
            } else if(e.target.className==='btnLocation'){
                this.setState({isLocationScreen:true});
                let popup = $('.popup--feedback');
                popup.css({display: 'block'});
            } else {
                if(this.state.preventDoubleClick){
                    // Add if any error message on double click
                    // console.log('already clicked!!');
                } else {
                    this.setState({query_count: this.state.query_count + 1, getConvCount: this.state.getConvCount + 1,preventAction:true}, () => { /*console.log('Query count: ',this.state.query_count); console.log('getConvCount count: ',this.state.getConvCount)*/ });
                    if(e.target.className==='btnGroupClass'){
                        btnText = e.target.innerText;
                        // console.log(btnText);

                        const button = e.target;
                        const svgElement = button.querySelector('.btn-inside-svg');
                        const svgInnerHTML = svgElement.innerHTML;
                        // console.log(svgInnerHTML);

                        getConv(btnText,this.state.inputTypeIs, svgInnerHTML, this.state.currentLanguage);
                        // getConv(btnText,this.state.inputTypeIs);
                    } else {
                        getConv(usrio,this.state.inputTypeIs, '', this.state.currentLanguage);
                    }
                    setTimeout(() => {
                        this.getConversationn(usrio);
                    }, 200);
                }
            }
        }      
    }

    sendButtonHandler=(e)=>{
        // console.log(e.target.id);
        e.preventDefault();
        let usrio=this.state.uservalue;
        if(this.state.inputTypeIs==='OTP'){
            usrio=getUserTextOTPValue();            
        }
        else if(this.state.inputTypeIs==='NationalId'){
            usrio=getUserTextNationalIdValue();            
        }
        else if(this.state.inputTypeIs==='Request'){
            usrio=getUserTextRequestValue();            
        }
        else if(this.state.inputTypeIs==='UDS'){
            usrio=getUserTextUDSValue();            
        }
        else if(this.state.inputTypeIs==='IBAN'){
            usrio=getUserTextIBANValue();            
        }
        else if(this.state.inputTypeIs==='Phone'){
            usrio=getUserTextPhoneValue();            
        }
            let usertext = checkUserTextValue(usrio,this.state.inputTypeIs,this.state.var1);
            // console.log(usertext);
            // console.log(this.state.messageListsData);
            if(!usertext && (usrio!=='Back' || usrio!=='الرجوع للخلف' || usrio!=='القائمة الرئيسية' || usrio!=='Main Menu')){ // TODO : update arabic back text
            if(this.state.inputTypeIs!=='Account' || this.state.inputTypeIs!=='Phone' || this.state.inputTypeIs!=='NationalId' || this.state.inputTypeIs!=='Payment'){
                appendUserTextMessage(this.state.currentLanguage,this.state.inputTypeIs,this.state.var1);
            }
        } else {
            this.setState({query_count: this.state.query_count + 1, freeText:true}, () => { /*console.log('Query count: ',this.state.query_count);*/ });
            // console.log(this.state.uservalue);
            if(this.state.inputTypeIs==='File' && (usrio === 'Back' || usrio === 'Main Menu')){
                getConv(usrio,this.state.inputTypeIs, '', this.state.currentLanguage);
            } else if(this.state.inputTypeIs==='File' && (usrio !== 'Back' || usrio !== 'Main Menu')){
                getConv(this.state.filename,this.state.inputTypeIs, '', this.state.currentLanguage);
            } else {
                getConv(usrio,this.state.inputTypeIs, '', this.state.currentLanguage);
            }
            setTimeout(() => {
                this.getConversationn(usrio);
            }, 200);
            this.setState({logs:{type:'',message:'',icon:'',refId:''}});
            this.setState({disableUsersAct:{textBx:true,refreshBtn:true,sendBtn:true}});
        }        
    }
    
    // Dropdown Change handler
    onChangeConvHandler = (e) => {
        e.preventDefault();
        this.setState({query_count: this.state.query_count + 1, getConvCount: this.state.getConvCount + 1}, () => { /*console.log('Query count: ',this.state.query_count); console.log('getConvCount count: ',this.state.getConvCount)*/ });
        // console.log(e);
        // console.log(e.target.value);
        let usrio = e.target.value;
        getConv(usrio,this.state.inputTypeIs, '', this.state.currentLanguage);
        setTimeout(() => {
            this.getConversationn(usrio);
        }, 200);
    }

    // Mobile Dropdown Change handler
    onMobileChangeConvHandler = (e) => {
        e.preventDefault();
        this.setState({query_count: this.state.query_count + 1, getConvCount: this.state.getConvCount + 1}, () => { /*console.log('Query count: ',this.state.query_count); console.log('getConvCount count: ',this.state.getConvCount)*/ });
        // console.log(e);
        // console.log(e.target.value);
        // let usrio = e.value;
        let usrio = e.target.getAttribute("data-value");
        getConv(usrio,this.state.inputTypeIs, '', this.state.currentLanguage);
        setTimeout(() => {
            this.getConversationn(usrio);
        }, 200);
    }
    // onMobileChangeConvHandler = (e) => {
    //     // e.preventDefault();
    //     this.setState({query_count: this.state.query_count + 1, getConvCount: this.state.getConvCount + 1}, () => { /*console.log('Query count: ',this.state.query_count); console.log('getConvCount count: ',this.state.getConvCount)*/ });
    //     // console.log(e);
    //     // console.log(e.target.value);
    //     let usrio = e.value;
    //     getConv(usrio,this.state.inputTypeIs, '', this.state.currentLanguage);
    //     setTimeout(() => {
    //         this.getConversationn(usrio);
    //     }, 200);
    // }

    // Currently <FeedbackPopup /> is disabled
    // To enable updated isFeedbackPupup state to true
    popupFeedbackHandler = (e)=> {
        e.preventDefault();
        // console.log(e.target.title);
        if(e.target.title==='Skip'){
            cancelFeedback(e);
        }        
    }

    iconActionHandler = (e)=> {
        e.preventDefault();
        // console.log(e.target.className);
        $('div[data-type = feedIcon]').removeClass('active');
        $('.'+e.target.className).addClass('active');       
    }

    // Refresh Button handler
    refreshHandler = (e)=>{
        e.preventDefault();
        if(!this.state.preventAction){
            resetMessageContainer();
            this.setState({query_count: 0,ccount:0,getConvCount:0,messageListsData:[],isWelcomeScreen:true,chatStatus:false});
            // console.log(e.target.id);
        } else { /*Do nothing*/ }
    }

    feedbackHandler = (e)=>{
        e.preventDefault();
        // console.log(e.target.id);
        $('#fb-popup').show();
    }

    // Close notification bar [currently only for copy contract numbers]
    closeNotificationHandler = (e)=>{
        e.preventDefault();
        closeNotification('notify');
        setTimeout(() => {
            this.setState({logs:{type:'',message:'',icon:'',refId:''}});
        }, 170);
    }

    // Header Language button handler
    languageHandler = (e)=>{
        e.preventDefault();
        if(!this.state.preventAction){
            // console.log(e.target.id);
            var cLang = e.target.id;
            if(cLang==='langEnBtn'){
                this.setState({currentLanguage:'en'});
            } else if(cLang==='langArBtn'){
                this.setState({currentLanguage:'ar'});
            } else {
                this.setState({currentLanguage:'en'});
            }
            resetVisitorsMessages();
            this.setState({query_count: 0,ccount:0,getConvCount:0,messageListsData:[]});
            this.startNewConversation();
        } else { /*Do nothing*/ }
    }

    // Welcome screen language button handler
    welcomelanguageHandler=(e)=>{
        e.preventDefault();
        // console.log(e.target.id);
        var cLang = e.target.id;
        if(cLang==='langEnBtn'){
            this.setState({currentLanguage:'en',chatStatus:true});
        } else if(cLang==='langArBtn'){
            this.setState({currentLanguage:'ar',chatStatus:true});
        } else {
            this.setState({currentLanguage:'en',chatStatus:true});
        }
        this.startNewConversation();
        setTimeout(()=>{
            this.setState({isWelcomeScreen:false,isTimeoutScreen:false});
        },300)
    }

    // Timeout message handler     -- not in used
    timeoutMessageHandler=(e)=>{
        e.preventDefault();
        if(!this.state.preventAction){
            resetMessageContainer();
            this.setState({query_count: 0,ccount:0,getConvCount:0,messageListsData:[],isWelcomeScreen:true,isTimeoutScreen:false,isLocationScreen:false,selectedFile:'', isFilePicked:false, filevalue:'', filetype:'', filename:'', filebase64:'', uservalue:'',chatStatus:false});
            // console.log(e.target.id);
        } else { /*Do nothing*/ }
    }

    // On close button on Welcome screen    -- not in used
    backToWelcomeHandler=(e)=>{
        e.preventDefault();
        // console.log(e.target.id);
        if(e.target.id==='backToWelcomeScreen'){
            this.setState({isTimeoutScreen:false,isWelcomeScreen:true,chatStatus:false});
        }
    }

    // Change state    -- not in used
    changeState(state){
        this.setState(state);
    }

    // Userinput text change handler
    changeHandler=event=>{
        // console.log(event.code);
        if(event.code === 'Enter' && !this.state.disableUsersAct.sendBtn){
            // console.log(this.state.disableUsersAct.sendBtn);
            // console.log(event.code);
        } else {
            let value=event.target.value;
            let numReg = /^[0-9]*$/;
            // if(this.state.inputTypeIs==='Phone' || this.state.inputTypeIs==='Account'){
            if(this.state.inputTypeIs==='Account' && value.length<12){
                if(numReg.test(value)){
                    this.setState({uservalue:value});
                }                
            } else if(this.state.inputTypeIs==='Account' && value.length>11){
                if(numReg.test(value)){
                    let val11 = value.substring(0, 11);
                    this.setState({uservalue:val11});
                }                
            } else if(this.state.inputTypeIs==='Payment' && value.length<13){
                if(numReg.test(value)){
                    this.setState({uservalue:value});
                }                
            } else if(this.state.inputTypeIs==='Payment' && value.length>12){
                if(numReg.test(value)){
                    let val12 = value.substring(0, 12);
                    this.setState({uservalue:val12});
                }                
            } else if(this.state.inputTypeIs==='Request' && value.length<10){
                if(numReg.test(value)){
                    this.setState({uservalue:value});
                }                
            } else if(this.state.inputTypeIs==='Request' && value.length>8){
                if(numReg.test(value)){
                    let val9 = value.substring(0, 9);
                    this.setState({uservalue:val9});
                }                
            } else if(this.state.inputTypeIs==='UDS' && value.length<10){
                if(numReg.test(value)){
                    this.setState({uservalue:value});
                }                
            } else if(this.state.inputTypeIs==='UDS' && value.length>9){
                if(numReg.test(value)){
                    let val9 = value.substring(0, 9);
                    this.setState({uservalue:val9});
                }                
            } else {
                this.setState({uservalue:value});
            }
            if(value!==''){this.setState({isActive:true})}
            else{this.setState({isActive:false})}
        }
    }

    // OTP text change handler
    otpChangeHandler=event=>{
        if(event.code === 'Enter' && !this.state.disableUsersAct.sendBtn){
            // console.log(this.state.disableUsersAct.sendBtn);
            // console.log(event.code);	
        } else {
            let value=event.target.value;
            this.setState({uservalue:value});
        }
    }

    // On press enter button
    keydownHandler=event=>{
        if(event.code === 'Enter' && !this.state.disableUsersAct.sendBtn){
            // console.log(this.state.disableUsersAct.sendBtn);
            // console.log(event.code);
            $('#button-body').trigger('click');
            // console.log('Enter pressed..! & Send Clicked..!!');
        }
    }

    // national id change handler
    nationalidChangeHandler=event=>{
        if(event.code === 'Enter' && !this.state.disableUsersAct.sendBtn){
            // console.log(this.state.disableUsersAct.sendBtn);
            // console.log(event.code);	
        } else {
            let value=event.target.value;
            this.setState({uservalue:value});
        }
    }

    // national id change handler
    IBANChangeHandler=event=>{
        if(event.code === 'Enter' && !this.state.disableUsersAct.sendBtn){
            // console.log(this.state.disableUsersAct.sendBtn);
            // console.log(event.code);	
        } else {
            let value=event.target.value;
            this.setState({uservalue:value});
        }
    }
    
    // Phone Number change handler
    PhoneChangeHandler=event=>{
        if(event.code === 'Enter' && !this.state.disableUsersAct.sendBtn){
            // console.log(this.state.disableUsersAct.sendBtn);
            // console.log(event.code);	
        } else {
            let value=event.target.value;
            this.setState({uservalue:value});
        }
    }
    
    // Request Number change handler
    ReqNumChangeHandler=event=>{
        if(event.code === 'Enter' && !this.state.disableUsersAct.sendBtn){
            // console.log(this.state.disableUsersAct.sendBtn);
            // console.log(event.code);	
        } else {
            let value=event.target.value;
            this.setState({uservalue:value});
        }
    }

    // UDS Number change handler
    UDSNumChangeHandler=event=>{
        if(event.code === 'Enter' && !this.state.disableUsersAct.sendBtn){
            // console.log(this.state.disableUsersAct.sendBtn);
            // console.log(event.code);	
        } else {
            let value=event.target.value;
            this.setState({uservalue:value});
        }
    }

    // Timeout handler function
    timeOut=()=>{
        var period = this.state.isTestData? sessionTimeTest: sessionTime;
        let trem1=0;
        this.state.tout=setInterval(()=>{
            period=period-1;
            let mesg='', LBL_Seconds='';
            if(this.state.currentLanguage==='ar'){
                mesg="خلال <span class='time Tnumber'>60</span> ثانية, سيتم تحديث الصفحة بسبب انتهاء صلاحية الجلسة.";
                LBL_Seconds='ثانية';
            } else {
                mesg="In <span class='time Tnumber'>60</span> seconds, the page will be refreshed due to the session expiration.";
                LBL_Seconds='seconds'
            }
            // console.log(trem1);
            trem1=period;
            if(trem1<=60){
                if(trem1===60){
                    var me=timeoutPre+mesg+timeoutPost;
                    $('.message-container').append(me);
                    $('.handle').click();
                }else if(trem1===0){                
                    // $('#errormodel').fadeIn('slow');
                    this.setState({isTimeoutScreen:true,chatStatus:false});
                    clearInterval(this.state.tout);
                }else{
                    $('.time').html(trem1);
                }
            }
        },1000);
    }

    // Uploaded file on remove handler
    removeFileHandler=event=>{
        this.setState({selectedFile:'', isFilePicked:false, filevalue:'', filetype:'', filename:'', filebase64:'', uservalue:''});
    }

    // On file upload action
    fileBtnChangeHandler=event=>{
        $(event.target).next('input').trigger('click');
    }
    
    // On file upload action
    fileChangeHandler = async (event) => {
        event.preventDefault();
        // Remove any element with class name 'keep'
        const elementToRemove = document.querySelector('.keep');
        if (elementToRemove) {
            elementToRemove.remove();
        }
    
        let evval = '';
        let _files = event.target.files[0];
        if (!_files) {
            // If no file is selected
            this.setState({
                selectedFile: '',
                isFilePicked: false,
                filevalue: '',
                filetype: '',
                filename: '',
                filebase64: '',
                uservalue: ''
            });
            return;
        }
    
        let _filesLwc = _files.name.toString().toLowerCase();
        let _fileName = _files.name;
    
        // Check file extension
        let _filesMatch = _filesLwc.match(/\.(jpg|jpeg|png|pdf|doc|docx)$/);
    
        // To check file size (<5.5MB)
        let _fileSize = _files.size < file_upload_limit ? true : false;
    
        // Define file compression options
        var options = {
            maxSizeMB: 2,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            onProgress: (progress) => {
                this.setState({ compressionProgress: progress });
            }
        };
    
        // If file type or size is invalid
        if (!_files || !_filesMatch || !_fileSize) {
            appendUserTextMessage(this.state.currentLanguage, this.state.inputTypeIs, this.state.var1);
            this.setState({
                selectedFile: '',
                isFilePicked: false,
                filevalue: '',
                filetype: '',
                filename: '',
                filebase64: '',
                uservalue: ''
            });
        } else if (_filesMatch && _fileSize) {
            const fileReader = new FileReader();
            fileReader.onloadend = async () => {
                const arr = new Uint8Array(fileReader.result).subarray(0, 4);
                let header = "";
                for (let i = 0; i < arr.length; i++) {
                    header += arr[i].toString(16);
                }
    
                let mimeType = "";
                switch (header) {
                    case "89504e47":
                        mimeType = "image/png";
                        break;
                    case "ffd8ffe0":
                    case "ffd8ffe1":
                    case "ffd8ffe2":
                    case "ffd8ffe3":
                    case "ffd8ffe8":
                        mimeType = "image/jpeg";
                        break;
                    case "25504446":
                        mimeType = "application/pdf";
                        break;
                    case "d0cf11e0":
                        mimeType = "application/msword"; // DOC (old Word format)
                        break;
 /*                   case "504b0304":
                    case "504b34":
                        mimeType = "application/zip"; // Initially mark as a ZIP
                        break;*/
                    default:
                        mimeType = "unknown"; // Invalid type
                        break;
                }
    
                if (mimeType === "application/zip") {
                    try {
                        const zipContent = await this.readAsTextPromise(_files);
    
                        if (zipContent.includes("[Content_Types].xml") && zipContent.includes("word/")) {
                            mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; // DOCX
                        } else {
                            this.setState({
                                selectedFile: '',
                                isFilePicked: false,
                                filevalue: '',
                                filetype: '',
                                filename: '',
                                filebase64: '',
                                uservalue: ''
                            });
                            appendUserTextMessage(this.state.currentLanguage, this.state.inputTypeIs, this.state.var1);
                            return;
                        }
                    } catch (error) {
                        console.error("Error reading ZIP content", error);
                        return;
                    }
                }
    
                // Validate the actual MIME type
                if (mimeType === "unknown") {
                    this.setState({
                        selectedFile: '',
                        isFilePicked: false,
                        filevalue: '',
                        filetype: '',
                        filename: '',
                        filebase64: '',
                        uservalue: ''
                    });
                    appendUserTextMessage(this.state.currentLanguage, this.state.inputTypeIs, this.state.var1);
                } else {
                    // MIME type is valid
                    if (mimeType.startsWith("image/")) {
                        // Handle image compression
                        try {
                            const compressedFile = await imageCompression(_files, options);
                            await this.compressImageFile(compressedFile, evval); // Call your image compression logic
                        } catch (error) {
                            console.error("Error compressing image", error);
                        }
                    } else {
                        // For non-image files (PDF, DOC, DOCX)
                        try {
                            const base64 = await getBase64(_files, (progress) => {
                                // Update state with the current progress
                                this.setState({ compressionProgress: progress });
                            });
                            this.setState({
                                selectedFile: _files,
                                filetype: _files.type,
                                filebase64: base64,
                                compressionProgress: 100 // Set to 100% on successful load
                            });
                        } catch (err) {
                            console.error("Error converting file to base64", err);
                            this.setState({ compressionProgress: 0 }); // Reset progress on error
                        }
                    }
    
                    this.setState({
                        isFilePicked: true,
                        filevalue: event.target.value,
                        filename: _fileName,
                        uservalue: _fileName
                    });
                }
            };
    
            // Read the file as an array buffer for MIME type validation
            fileReader.readAsArrayBuffer(_files);
        } else {
            this.setState({
                selectedFile: '',
                isFilePicked: false,
                filevalue: '',
                filetype: '',
                filename: '',
                filebase64: '',
                uservalue: ''
            });
        }
    };
    

    readAsTextPromise = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsText(file);
        });
    }; 

    compressPDFFile=(_files, options)=>{
        // console.log('is pdf application');        
    }

    compressDOCFile=(_files, options)=>{
        // console.log('is doc/docx application');
    }

    compressImageFile=(compressedFile, evval)=>{        
        // console.log('__Comp file size: ', compressedFile.size);
        // console.log('evval: ', evval);
        let __fileVal = evval;
        let __fileName = compressedFile.name;
        let base64;
        getBase64(compressedFile)
        .then(result => {
            base64 = result;
            // console.log("File Is", result);
            // console.log("File Is", compressedFile.name);
            this.setState({selectedFile:compressedFile, filetype:compressedFile.type, filebase64:result});
        })
        .catch(err => {
            // console.log(err);
        });       
    }

    // On location select/pick handler
    locationChangeHandler=e=>{
        let lat = e.target.getAttribute("data-lat");
        let lng = e.target.getAttribute("data-lng");
        let latlng = lat+','+lng;
        // let latlng = parseFloat(lat).toFixed(5)+','+parseFloat(lng).toFixed(5);

        const locationText = {
            english: {
                edit: "Edit location",
                share: "Share your location"
            },
            arabic: {
                edit: "تعديل الموقع",
                share: "تحديد الموقع"
            }
        };

        const buttonWrappers = document.querySelectorAll('.button-wrapper');

        // Get the last 'button-wrapper'
        const lastButtonWrapper = buttonWrappers[buttonWrappers.length - 1];

        if (lastButtonWrapper) {
            const lastButton = lastButtonWrapper.querySelector('.btnLocation');

            if (lastButton) {
                if (lastButton.textContent === locationText.english.share) {
                    lastButton.textContent = locationText.english.edit;
                    lastButton.title = locationText.english.edit;
                } else if (lastButton.textContent === locationText.arabic.share) {
                    lastButton.textContent = locationText.arabic.edit;
                    lastButton.title = locationText.arabic.edit;
                }
            }
        }
        console.log('Lat: '+ parseFloat("15.856878948").toFixed(5) + " , Org: " + lat)
        this.setState({isLocationScreen:false,uservalue:latlng, setGeoPosition: {lat: Number(lat), lng: Number(lng)}});
        // this.setState({isLocationScreen:false,uservalue:latlng, setGeoPosition: {lat: parseFloat(lat).toFixed(5), lng: parseFloat(lng).toFixed(5)}});
    }

    locationCloseHandler=event=>{
        this.setState({isLocationScreen:false});
    }

    // -- not in used
    minimizeActionHandler=()=>{       
        window.parent.postMessage('CallMinimize', '*')
    }

    /* 21-Apr-22 Datepicker */
    changeGetDateHandler=(date)=>{
        this.setState({billDate:Moment(date).format("YYYY-MM-DD"),uservalue:Moment(date).format("YYYY-MM-DD")});
        // console.log('Selected Date: ', date);
        // console.log('Formated Date: ', Moment(date).format("YYYY-MM-DD"));
    }

    /* 21-Apr-22 Copy to clipboard */
    copyBtnHandler=(e)=>{
        e.preventDefault();
        var ccVal = e.target.getAttribute("data-value");
        var textarea = $('<textarea />');
        textarea.val(ccVal).css({
            //visibility: 'none'
        }).prependTo('body');
        textarea.select();
        if (document.execCommand('copy')) {
            // console.log('Copied!');
            let mesgg='';
            if(this.state.currentLanguage==='ar'){
                mesgg="نسخ!";
            } else {
                mesgg="Copied!";
            }
            this.setState({logs:{type:'success',message:mesgg,refId:'active',icon:'fe fe-rotate-cw fe-spin'}});
            textarea.remove();
            // Call to autoclose notify
            this.autoCloseCopiedNotify(5000);
            return true;
        }
    }

    /* Auto close copied notification */
    autoCloseCopiedNotify=(time)=>{
        time || 3000;
        setTimeout(()=>{
            closeNotification('notify');
            setTimeout(() => {
                this.setState({logs:{type:'',message:'',icon:'',refId:''}});
            }, 170);
        },time);
    }

    /* Edit click handler */
    onEditClickHandler = (e) => {
        e.preventDefault();
        this.setState({query_count: this.state.query_count + 1, getConvCount: this.state.getConvCount + 1}, () => { /*console.log('Query count: ',this.state.query_count); console.log('getConvCount count: ',this.state.getConvCount)*/ });
        // console.log(e);
        // console.log(e.target.title);
        let ele = document.querySelector('.editLink');
        let elea = document.querySelector('.addLink');
        // let ele = e.target.className;
        // ele.classList.add('disabled');
        // elea.classList.add('disabled');
        let usrio = e.target.getAttribute("data-value");
        getConv(usrio,this.state.inputTypeIs, '', this.state.currentLanguage);
        setTimeout(() => {
            this.getConversationn(usrio);
        }, 200);
    }

    render() {
        return (
            <TopContainer
                iconbot={this.state.currentIcon}
                language={this.state.currentLanguage}
            >
                <React.Fragment>
                    <ChatHeader
                        minimizeAction={this.minimizeActionHandler}
                        isSpeaker={this.state.isSpeaker}
                        speakerAction=''
                        englishTitle={this.state.engTitle}
                        arabicTitle={this.state.arbTitle}
                        isAgent={this.state.isAgent}
                        isLanguageBtn={this.state.isLanguageBtn}
                        languageAction={this.languageHandler}
                        language={this.state.currentLanguage}
                        headerStatus={this.state.chatStatus}
                        isServiceBusy={this.state.isBusy}
                    ></ChatHeader>
                    <Notify
                        logList={this.state.logs}
                        action={this.closeNotificationHandler}
                    ></Notify>

                    {this.state.isWelcomeScreen?(
                        <WelcomeModal
                            isWelcomeScr={this.state.isWelcomeScreen}
                            language={this.state.currentLanguage}
                            welcomelangAction={this.welcomelanguageHandler}
                            minimizeAction={this.minimizeActionHandler}
                        ></WelcomeModal>
                    )
                    :this.state.isTimeoutScreen?(
                        <TimeoutScreen
                            isFirstMessageScr={this.state.isTimeoutScreen}
                            timeoutMessageAction={this.timeoutMessageHandler}
                            backtoAction={this.backToWelcomeHandler}
                            minimizeAction={this.minimizeActionHandler}
                            language={this.state.currentLanguage}
                        	inputType={this.state.inputTypeIs}
                        ></TimeoutScreen>
                    ):(
                        <React.Fragment>
                            <MessageContainer
                                messageLists={this.state.messageListsData}
                                btnActions={this.getConvHandler}
                                dropdownChange={this.onChangeConvHandler}
                                mobileDropdownChange={this.onMobileChangeConvHandler}
                                disableElement={this.state.disableUsersAct}
                                stateChange={this.changeState.bind(this)}
                                language={this.state.currentLanguage}
                                changeHandler={this.fileChangeHandler}
                                btnChangeHandler={this.fileBtnChangeHandler}
                                isSelected={this.state.isFilePicked}
                                filevalue={this.state.filevalue}
                                selectedFile={this.state.selectedFile}
                                removeFileHandler={this.removeFileHandler}
                                acceptFormat={this.state.allowTypes}
                                datePicAction={this.changeGetDateHandler}
                                editBtnHandler={this.onEditClickHandler}
                                copyBtnHandler={this.copyBtnHandler}
                                isMainMenu={this.state.isMainMenu}
                                isTest={this.state.isTestData}
                                botTitle={this.state.engTitle}
                                userTitle={'You'}
                                filebase64={this.state.filebase64}
                                compressionProgress={this.state.compressionProgress}
                            ></MessageContainer>

                            {this.state.isFeedbackPupup?(
                                <FeedbackPopup
                                    action={this.popupFeedbackHandler}
                                    iconAction={this.iconActionHandler}
                                ></FeedbackPopup>
                            ):(null)}

                            <UserInputArea
                                refreshAction={this.refreshHandler}
                                language={this.state.currentLanguage}
                                // feedbackAction={this.feedbackHandler}
                                isMic={this.state.isMic}
                                micAction=''
                                disableElement={this.state.disableUsersAct}
                                value={this.state.uservalue}
                                handleChange={this.changeHandler}
                                handleOtpChange={this.otpChangeHandler}
                                handleKeydown={this.keydownHandler}
                                handleNationalIdChange={this.nationalidChangeHandler}
                                nationalidhandleKeydown={this.nationalidskeydownHandler}
                                handleIBANChange={this.IBANChangeHandler}
                                handlePhoneChange={this.PhoneChangeHandler}
                                handleReqNumChange={this.ReqNumChangeHandler}
                                handleUDSNumChange={this.UDSNumChangeHandler}
                                inputType={this.state.inputTypeIs}
                                btnActions={this.getConvHandler}
                                isMainMenu={this.state.isMainMenu}
                                messageLists={this.state.messageListsData}
                                isLanguageBtn={this.state.isLanguageBtn}
                                languageAction={this.languageHandler}
                                isServiceBusy={this.state.isBusy}
                            ></UserInputArea>
                            <SendButton
                                sendAction={this.sendButtonHandler}
                                disableElement={this.state.disableUsersAct}
                                inputText={this.state.isActive}
                                language={this.state.currentLanguage}
                            ></SendButton>
                        </React.Fragment>
                    )}
                    
                    <PopupModal
                        action={this.refreshHandler}
                    ></PopupModal>
                    {this.state.isLocationScreen?(
                        <PopupAlert
                            language={this.state.currentLanguage}
                            action={this.locationChangeHandler}
                            closeButtonShow='false'
                            closeAction={this.locationCloseHandler}
                            value={this.state.locationValue}
                            geoPosition={this.state.setGeoPosition}
                        ></PopupAlert>
                    ):(null)}
                </React.Fragment>
            </TopContainer>
        );
    }
}
 
export default ChatBot;